var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2276 1.79662C17.6747 1.22784 17.0172 0.776312 16.2929 0.467985C15.5686 0.159657 14.7918 0.000614176 14.0071 0C12.5229 0.000247838 11.0929 0.569789 10.0002 1.59586C8.90769 0.569616 7.47762 4.76847e-05 5.99338 0C5.20779 0.000835522 4.43012 0.160364 3.70511 0.469404C2.98011 0.778444 2.32209 1.23089 1.76892 1.80072C-0.590476 4.22113 -0.589474 8.00694 1.77093 10.4171L10.0002 18.8235L18.2296 10.4171C20.59 8.00694 20.591 4.22113 18.2276 1.79662Z",
    fill: "#C44545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLikeIcon);
export default __webpack_public_path__ + "static/media/HeartLikeIcon.e986fe55ac43054bb938bc0bd884db3b.svg";
export { ForwardRef as ReactComponent };